module.exports = __webpack_public_path__ + "media/assets/images/html_editor/undo-72ac0e2d09eb896ab9489c21ce2a46c8.svg";